import { useRef, useState } from "react";
import { uploadList } from "../../data/doc";
import { docList } from "../../constants/docs";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { useNavigate } from "react-router-dom";
import PDFIcon from "../../assets/icons/file-pdf.svg";
import DocIcon from "../../assets/icons/file-doc.svg";
import ImgIcon from "../../assets/icons/file-img.svg";
import SheetIcon from "../../assets/icons/file-sheet.svg";
import DefaultIcon from "../../assets/icons/file-default.svg";
import ArrowbackIcon from "../../assets/icons/arrow_back.svg";
import SearchIcon from "../../assets/icons/search.svg";
import SortIcon from "../../assets/icons/sort.svg";
import ViewIcon from "../../assets/icons/visibility.svg";
import DownloadIcon from "../../assets/icons/download.svg";
import UserIcon from "../../assets/images/Avatar.png";
import DocImg from "../../assets/images/doc.png";
import BotIcon from "../../assets/icons/smart_toy.svg";
import CommonModal from "../../commonComponents/CommonModal";
import FilePreviewModal from "../../components/FilePreviewModal";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "./Documents.css";

const Documents = () => {
  const navigate = useNavigate();
  const [navSelected, setNavSelected] = useState("hr");
  const [pdfSelected, setPdfSelected] = useState({});
  const [modalToggle, setModalToggle] = useState(false);
  const openModalRef = useRef();
  const closeModalRef = useRef();

  const fileTypeandIconSelected = (fileName) => {
    const fileType = fileName.split(".").pop().toLowerCase();
    let fileIcon = "";
    switch (fileType) {
      case "pdf":
        fileIcon = PDFIcon;
        break;
      case "doc":
      case "docx":
        fileIcon = DocIcon;
        break;
      case "jpg":
      case "jpeg":
      case "png":
        fileIcon = ImgIcon;
        break;
      case "xls":
      case "xlsx":
        fileIcon = SheetIcon;
        break;
      default:
        fileIcon = DefaultIcon;
    }
    return fileIcon;
  };

  const PDFPreview = () => (
    <div>
      <Worker
        workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
      >
        <Viewer fileUrl={`${process.env.PUBLIC_URL}/${pdfSelected.filePath}`} />{" "}
      </Worker>
    </div>
  );

  return (
    <div className="dc-home">
      <div className="flex items-center">
        <button
          type="button"
          aria-label="Back to all modules"
          className="xl:hidden mr-3 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-100 border-0"
          onClick={() => navigate("../all")}
        >
          <img src={ArrowbackIcon} alt="Back" className="h-5 w-5" />
        </button>
        <div className="dc-head !px-0 font-semibold">documents</div>
      </div>
      <div className="flex form-nav">
        <div
          className={`flex items-center doc-nav-item ${
            navSelected === "hr" && "active"
          }`}
          onClick={() => setNavSelected("hr")}
        >
          <a href="#hr" className="doc-nav-text">
            HR Documents
          </a>
        </div>
      </div>
      {navSelected === "hr" && (
        <>
          <div className="dc-card-list">
            {docList?.map((doc, i) => (
              <div
                className="doc-pr-card cursor-pointer"
                onClick={() => {
                  setPdfSelected(doc);
                  setModalToggle(true);
                }}
              >
                <div className="doc-ico-wrap">
                  <img
                    className="doc-ico"
                    src={fileTypeandIconSelected(doc?.fileName)}
                    alt="doc"
                  />
                </div>
                <div className="doc-file-details">
                  <div className="doc-file-name">{doc?.fileName}</div>
                  <div className="doc-file-date">{doc?.date}</div>
                </div>
              </div>
            ))}
            {/* <div
              className="doc-pr-card cursor-pointer"
              onClick={() => {
                setPdfSelected(docList[15]);
                setModalToggle(true);
              }}
            >
              <div className="doc-ico-wrap">
                <img
                  className="doc-ico"
                  src={fileTypeandIconSelected(docList[15]?.fileName)}
                  alt="doc"
                />
              </div>
              <div className="doc-file-details">
                <div className="doc-file-name">{docList[15]?.fileName}</div>
                <div className="doc-file-date">{docList[15]?.date}</div>
              </div>
            </div> */}
          </div>
        </>
      )}
      {navSelected === "doc" && (
        <>
          <div className="flex dc-filter">
            <div className="dc-search-wrap">
              <img src={SearchIcon} className="filter-icon" alt="" />
            </div>
            <div className="dc-sort-bar"></div>
            <div className="flex dc-sort-wrap">
              <img src={SortIcon} className="filter-icon" alt="" />
              <div className="dc-filter-text">Sort</div>
            </div>
            <div className="dc-sort-bar"></div>
            <div className="flex dc-sort-wrap mr8">
              <div className="dc-filter-text">Personal Documents</div>
              <div className="dc-filter-count">4</div>
            </div>
            <div className="flex dc-sort-wrap mr8">
              <div className="dc-filter-text">Miscellaneous</div>
              <div className="dc-filter-count">3</div>
            </div>
          </div>
          <div className="dc-card-list">
            {uploadList?.map((doc, i) => (
              <div className="dc-card">
                <div className="dc-main-box">
                  <div className="flex justify-between w-full p-12 mb-auto">
                    <div className="dc-card-head">{doc?.docName}</div>
                    <div className="flex items-center">
                      <div className="dc-card-ico-wrap">
                        <img src={ViewIcon} className="dc-card-ico" alt="" />
                      </div>
                      <div className="dc-card-ico-wrap">
                        <img
                          src={DownloadIcon}
                          className="dc-card-ico"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <img className="dc-file-preview" src={DocImg} alt="doc" />
                  <div className="flex dc-card-nameplate mt-auto w-full p-12">
                    <div className="mr-auto dc-card-filename">
                      {doc?.fileName}
                    </div>
                  </div>
                </div>
                <div className="dc-sub-box flex justify-between">
                  <div className="flex items-center">
                    <img
                      className="dc-usr-ico"
                      src={doc?.docAuthor ? BotIcon : UserIcon}
                      alt=""
                    />
                    <div className="dc-usr-name">
                      {doc?.author || doc?.docAuthor}
                    </div>
                  </div>
                  <div className="dc-date ml-auto">{doc?.date}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      <FilePreviewModal
        fileUrl={`${process.env.PUBLIC_URL}/${pdfSelected?.filePath}`}
        modalToggle={modalToggle}
        onClose={() => setModalToggle(false)}
      />
      <CommonModal
        openRef={openModalRef}
        closeRef={closeModalRef}
        id={"separationConfirmModal"}
        hideCloseButton={false}
        content={<PDFPreview />}
        disabled={false}
        size={"xl"}
      />
    </div>
  );
};
export default Documents;
